/**
 * Iter v34cw (#5) — Pencarian kombinasi kata.
 *
 * Query dipecah per-spasi menjadi token; sebuah baris cocok hanya bila SEMUA
 * token ditemukan di gabungan field yang dicari (urutan & huruf besar/kecil
 * diabaikan). Contoh: "sekawan pasir" → SJ klien Sekawan yang materialnya pasir.
 */
export function matchesTokens(haystack, query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return true;
  const hay = (haystack || "").toLowerCase();
  return q.split(/\s+/).every((tok) => hay.includes(tok));
}

/** Gabungkan beberapa nilai menjadi satu haystack untuk matchesTokens. */
export function buildHaystack(...values) {
  return values.flat(3).filter(Boolean).join(" \u00b7 ");
}
